import { spacing2, spacing6 } from 'src/styles/spacing';

import { ParagraphPlaceholderTheme } from './paragraph-placeholder-theme';

export const defaultParagraphPlaceholderStyles: ParagraphPlaceholderTheme = {
  container: {
    marginBottom: '0',
    centeredOnMobile: false,
  },
  title: {
    marginBottom: spacing6,
    height: '24px',
    width: '440px',
  },
  paragraph: {
    spaceBetweenLines: spacing2,
    width: '235px',
  },
};
